const { createContext } = require("react");

export const FormContext = createContext();